import React from "react";
import { useParams } from "react-router-dom";
import ThanksWrapperArea from "./ThanksWrapperArea";

function Thanks() {

  const { ctype } = useParams(); // mode will be "online" or "onsite"
  const { hash } = useParams(); // hash is the unique booking hash

  return (
    <>
      <ThanksWrapperArea ctype={ctype} hash={hash} />
    </>
  );
}

export default Thanks;
